import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";

import Topbar from "./scenes/global/topbar";
import Gallery from "./scenes/gallery";
import Pics from "./scenes/global/pics";
import LandingPage from "./scenes/landingPage";
import Footer from "./scenes/global/footer";
import GalleryDetail from "./scenes/gallery_detail";
import Shop from "./scenes/shop";
import ShopDetail from "./scenes/shop_detail";
import About from "./scenes/about";
import Contact from "./scenes/contact";
import Design from "./scenes/design";
import DesignDetail from "./scenes/design_detail";
import Admin from "./scenes/admin_panel";
import Login from "./scenes/login";


const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};


const App = () => {

  const isAuthenticated =
    localStorage.getItem("isAdminLoggedIn") === "true";

  return (
    <Router>
      <ScrollToTop />

      <Routes>

        {/* ========================= */}
        {/* Public Website */}
        {/* ========================= */}

        <Route
          path="/*"
          element={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                position: "relative",
              }}
            >
              <Pics />

              <Topbar />

              <div style={{ flex: 1 }}>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route
                    path="/gallery-detail/:id"
                    element={<GalleryDetail />}
                  />
                  <Route path="/shop" element={<Shop />} />
                  <Route
                    path="/shop-detail/:id"
                    element={<ShopDetail />}
                  />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/design" element={<Design />} />
                  <Route
                    path="/design-detail/:id"
                    element={<DesignDetail />}
                  />
                </Routes>
              </div>

              <Footer />
            </div>
          }
        />

        {/* ========================= */}
        {/* Login */}
        {/* ========================= */}

        <Route
          path="/login"
          element={
            isAuthenticated
              ? <Navigate to="/" replace />
              : <Login />
          }
        />

        {/* ========================= */}
        {/* Admin */}
        {/* ========================= */}

        <Route
          path="/admin"
          element={
            isAuthenticated
              ? <Admin />
              : <Navigate to="/login" replace />
          }
        />

      </Routes>
    </Router>
  );
};

export default App;